<template>
  <div>
    <hub-icon name="loading" spin size="lg"></hub-icon>
  </div>
</template>

<script>
import Icon from './../common/Icon';
export default {
  components: {
    'hub-icon': Icon
  },
  data() {
    return {
      timeout: null,
      visible: false
    };
  },
  created() {
    this.visible = false;
    this.timeout = setTimeout(() => {
      this.visible = true;
      this.timeout = null;
    }, 100);
  },
  unmounted() {
    this.timeout && clearTimeout(this.timeout);
  }
};
</script>

<style lang="scss" scoped>
div {
  display: inline-flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -100%);

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.1;
    }
  }

  img {
    animation: pulse 2s infinite linear;
    max-height: 50px;
  }
}
</style>
